import { useObserver } from "mobx-react-lite";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useStores } from "../../store";
import { name } from "../../services/white_label";

const InterviewPreview = ({
  companyLogo,
  companyName,
  totalQuestions,
  totalFollowupQuestions,
  cutOff,
  attributes,
  level,
  interviewtype,
  technology,
  handleClick,
}) => {
  const { RecuiterStore } = useStores();
  const interviewSetting = [
    // { id: 1, label: "Candidate Video", name: "video" },
    { id: 2, label: "Screen Recording", name: "screen" },
    { id: 3, label: "Allow Candidate to type answers", name: "typing" },
    { id: 4, label: "Allow to take Interview from Mobile", name: "mobile" },
    // { id: 5, label: "Reveal Actual answers", name: "actualAnswers" },
    // { id: 6, label: "Show report to the candidate", name: "report" },
    { id: 7, label: "Proxy Detection", name: "proxy" },
    // { id: 8, label: `Show job post in ${name()}`, name: "showJobPost" },
    // {
    //   id: 11,
    //   label: "Allow to change tab",
    //   name: "tabChange",
    //   tooltip: "Allow candidates to change tabs during the interview.",
    // },
    { id: 9, label: "Resume", name: "resume" },
    // { id: 10, label: "Candidate pay for the interview", name: "candidatePay" },
  ];
  const ShowAssessment = RecuiterStore.jobPostDetails.customSettings?.find(
    (item) => item.name === "scheduleAssessment"
  ).value;

  return useObserver(() => (
    <div className="bg-white flex flex-col gap-6  rounded-2xl shadow-md w-full max-w-[90%] m-10 mx-20">
      {/* Header */}
      <div className="flex items-center rounded-t-2xl space-x-4 p-4 md:p-8 lg:p-8 bg-[#E9E9E9]">
        <img src={companyLogo} alt="Company Logo" className="w-20 h-20 " />
        <div>
          <h2 className="text-xl font-semibold">{companyName}</h2>
          <h2 className="text-lg font-semibold text-gray-500">{technology}</h2>

          <div className=" md:space-x-4 lg:space-x-4 space-x-0 grid grid-cols-1 gap-2 md:flex lg:flex  mt-1">
            <h2 className="bg-[#D4D4D4] md:px-3  lg:px-3 md:py-1 lg:py-1 px-3 py-[4px]  rounded-md text-sm ">
              {interviewtype}
            </h2>
            {attributes
              .filter((attribute) => attribute.show)
              .map((attribute) => (
                <span
                  key={attribute.id}
                  className="bg-[#D4D4D4]  px-3 py-1 rounded-md text-sm"
                >
                  {attribute.name}:{" "}
                  {attribute.value === "" ? "Not Mentioned" : attribute.value}
                </span>
              ))}
          </div>
        </div>
      </div>
      {/* Assessment Settings */}
      <div className=" px-8">
        <h3 className="text-lg font-semibold mb-2">Assessment Settings</h3>
        <div className="grid grid-cols-1  md:grid-cols-4  gap-3">
          
          {interviewSetting
            // .filter((setting) => setting.label !== "candidatePay")
            .map((setting) => {
              const match = RecuiterStore.jobPostDetails.customSettings?.find(
                (item) => item.name === setting.name
              );
              return (
                <div key={setting.id} className="flex items-center space-x-2">
                  {match?.value ? (
                    <FaCheckCircle className="text-green-500" size={18} />
                  ) : (
                    <FaTimesCircle className="text-red-500" size={18} />
                  )}
                  <span className="text-sm">{setting.label}</span>
                </div>
              );
            })}
        </div>
      </div>
      {/* Job Post Schedule */}
      {ShowAssessment && (
        <div className="mt-6 px-8">
          <h3 className="text-lg font-semibold mb-2">Job Post Schedule</h3>
          <div className="flex space-x-4">
            {/* Start Date */}
            <div className="flex items-center border border-gray-300 rounded-lg h-10 overflow-hidden p-2 max-w-[450px] w-full focus-within:border-blue-500">
              <label className="text-sm text-gray-600 w-2/3">
                Assessment Start Date
              </label>
              <input
                type="date"
                value={
                  RecuiterStore.jobPostDetails.customSettings?.find(
                    (item) => item.name === "startDate"
                  )?.value || ""
                }
                className="border-none outline-none p-2 w-1/3 focus:ring-0"
              />
            </div>

            {/* End Date */}
            <div className="flex items-center border border-gray-300 rounded-lg p-2 h-10 w-full max-w-[450px] overflow-hidden focus-within:border-blue-500">
              <label className="text-sm text-gray-600 w-2/3">
                Assessment End Date
              </label>
              <input
                type="date"
                value={
                  RecuiterStore.jobPostDetails.customSettings?.find(
                    (item) => item.name === "endDate"
                  )?.value || ""
                }
                className="border-none outline-none p-2 w-1/3 focus:ring-0"
              />
            </div>
          </div>
        </div>
      )}
      {/* Post Job Button */}
      <div className="my-6 px-8 md:mb-5 lg:mb-5 mb-14">
        <button
          className="bg-orange-500 text-white px-6 py-2 rounded-md"
          onClick={handleClick}
        >
          {window.location.pathname.includes("job-post") ? "Post Job" :
           window.location.pathname.includes("interview") ? "Post Interview" :
           window.location.pathname.includes("mcq") ? "Post MCQ" : "Post"}
        </button>
      </div>
    </div>
  ));
};

export default InterviewPreview;
